import { SVGAttributes } from 'react'

const CalendarIcon = ({
  className,
  fill = 'rgb(var(--line-neutral))',
  ...props
}: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M6.02765 1.51083C5.61365 1.51083 5.27765 1.84683 5.27765 2.26083C3.6194 2.26083 2.25439 3.60558 2.25439 5.26083V6.76083L2.27765 12.7608C2.27765 14.4153 3.6209 15.7608 5.27765 15.7608H12.7776C14.4344 15.7608 15.7776 14.4176 15.7776 12.7608L15.7544 6.76083V5.26083C15.7544 3.60258 14.4329 2.26083 12.7776 2.26083C12.7776 1.84683 12.4424 1.51083 12.0276 1.51083C11.6136 1.51083 11.2776 1.84683 11.2776 2.26083H6.77765C6.77765 1.84683 6.4424 1.51083 6.02765 1.51083ZM5.27765 3.76083C5.27765 4.17483 5.61365 4.51083 6.02765 4.51083C6.4424 4.51083 6.77765 4.17483 6.77765 3.76083H11.2776C11.2776 4.17483 11.6136 4.51083 12.0276 4.51083C12.4424 4.51083 12.7776 4.17483 12.7776 3.76083C13.6004 3.76083 14.2544 4.42683 14.2544 5.26083V6.01083C12.8114 6.01083 5.19739 6.01083 3.75439 6.01083V5.26083C3.75439 4.43808 4.44365 3.76083 5.27765 3.76083ZM3.75439 7.51083C5.19739 7.51083 12.8114 7.51083 14.2544 7.51083L14.2776 12.7608C14.2776 13.5866 13.6064 14.2608 12.7776 14.2608H5.27765C4.44965 14.2608 3.77765 13.5896 3.77765 12.7608L3.75439 7.51083Z"
        fill={fill}
      />
    </svg>
  )
}

export default CalendarIcon
